import React from 'react';
import {
  Sparkles,
  Gem,
  Droplet,
  Hand,
  Palette,
  Wrench,
} from 'lucide-react';
import { services } from '../mock';

const iconMap = { Sparkles, Gem, Droplet, Hand, Palette, Wrench };

const Services = () => {
  const scrollToBooking = () => {
    const el = document.querySelector('#booking');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="services"
      className="py-20 md:py-28 bg-gradient-to-b from-pink-50/50 via-white to-pink-50/50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 bg-white border border-pink-200 text-pink-600 rounded-full px-3 py-1 text-xs font-semibold tracking-wider mb-4">
            OUR OFFERINGS
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900">
            Our <span className="gradient-text">Services</span>
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            Professional nail care tailored to your style
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || Sparkles;
            return (
              <div
                key={service.id}
                className="card-lift bg-white rounded-2xl p-7 border border-pink-100 shadow-sm"
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-pink-100 to-rose-100 flex items-center justify-center mb-5">
                  <Icon className="h-6 w-6 text-pink-600" />
                </div>
                <h3 className="font-display text-2xl font-semibold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
                <div className="mt-6 pt-5 border-t border-pink-100 flex items-center justify-between">
                  <span className="text-sm text-pink-600 font-medium">{service.price}</span>
                  <button
                    onClick={scrollToBooking}
                    className="text-sm font-semibold text-pink-600 hover:text-rose-600 transition"
                  >
                    Book &rarr;
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
